module.exports = __webpack_public_path__ + "static/media/time-red.e45c1d7d.svg";